import { render, staticRenderFns } from "./ContractCommissionSettings.vue?vue&type=template&id=42313133"
import script from "./ContractCommissionSettings.vue?vue&type=script&lang=js"
export * from "./ContractCommissionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports